import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { ruRU, enUS, dateRuRU, dateEnUS, type NLocale, type NDateLocale } from 'naive-ui'

import { i18n, setLocale, type AppLocale } from '@/i18n'

export const useLocaleStore = defineStore('locale', () => {
  const current = ref<AppLocale>(i18n.global.locale.value as AppLocale)

  const naiveLocale = computed<NLocale>(() => (current.value === 'ru-RU' ? ruRU : enUS))
  const naiveDateLocale = computed<NDateLocale>(() =>
    current.value === 'ru-RU' ? dateRuRU : dateEnUS,
  )

  function set(loc: AppLocale): void {
    current.value = loc
    setLocale(loc)
  }

  return { current, naiveLocale, naiveDateLocale, set }
})
